import { Facet, FacetState, FacetType, FacetValue } from '@models';
import { BaseComponent } from '../base.component';
import { FacetWrapperComponent } from '../facet-wrapper/facet-wrapper.component';
import defaultHtml from './facets-list.component.hbs';

export class FacetsListComponent extends BaseComponent<Array<Facet>> {
    protected override bindEvent = 'hawksearch:bind-facets-list';
    protected override customTemplatePropertyName = 'facetsList';
    protected override defaultHtml = defaultHtml;

    private readonly state: {
        [key: number]: FacetState;
        expanded: boolean;
    } = {
        expanded: false
    };

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data) {
            return '';
        }

        const supportedTypes: Array<FacetType> = [
            'checkbox',
            'color',
            'date-range',
            'link',
            'numeric-range',
            'range-slider',
            'recent-searches',
            'related-searches',
            'search',
            'size'
        ];

        const html = template({
            facets: this.data.filter((f) => supportedTypes.includes(f.type)),
            expanded: this.state.expanded
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-mobile-toggle]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                this.state.expanded = !this.state.expanded;

                this.renderContent();
            });
        });

        this.shadowRoot?.querySelectorAll<FacetWrapperComponent>('hawksearch-facet-wrapper[hawksearch-facet-id]').forEach((component) => {
            const id = parseInt(component.getAttribute('hawksearch-facet-id') ?? '');
            const facet = this.data?.find((f) => f.id === id);

            let facetValues: Array<string> | undefined;

            if (facet?.values) {
                facetValues = [];

                const addValues = (values: Array<FacetValue> | undefined): void => {
                    values?.forEach((v) => {
                        if (v.value) {
                            facetValues!.push(v.value);
                        }

                        addValues(v.children);
                    });
                };

                addValues(facet.values);
            }

            let facetState = this.state[id];

            if (!facetState) {
                facetState = {
                    id: id,
                    toggled: false,
                    values: {}
                };

                this.state[id] = facetState;
            }

            facetValues?.forEach((v) => {
                const state = facetState.values![v];

                if (!state) {
                    facetState.values![v] = {
                        toggled: false
                    };
                }
            });

            component.data = facet;
            component.state = facetState;
        });
    }
}
